import { render, staticRenderFns } from "./ScientificProductionStats.vue?vue&type=template&id=495b7d22&"
import script from "./ScientificProductionStats.vue?vue&type=script&lang=js&"
export * from "./ScientificProductionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports